import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/shared/PageHero";
import CTASection from "@/components/shared/CTASection";
import VibrantSectionHeader from "@/components/shared/VibrantSectionHeader";
import ProjectCard from "@/components/projects/ProjectCard";
import ProjectStats from "@/components/projects/ProjectStats";
import ProjectProcess from "@/components/projects/ProjectProcess";
import PageSEO from "@/components/shared/PageSEO";
import Breadcrumbs from "@/components/shared/Breadcrumbs";
import { projects } from "@/data/projects";

const Projects = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Mobility Projects Saudi Arabia"
        description="Explore SDC's micro mobility projects across Saudi Arabia and the GCC — patrol fleet deployments, smart city mobility and event operations."
        keywords="mobility projects Saudi Arabia, micro mobility deployment KSA, smart city mobility Saudi, electric vehicle projects GCC, fleet deployment case studies"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "SDC Mobility Projects",
          "description": "Case studies of micro mobility deployments delivered by SDC across Saudi Arabia and the GCC.",
          "url": "https://sdcgulf.com/projects",
          "mainEntity": {
            "@type": "ItemList",
            "itemListElement": projects.map((p, i) => ({
              "@type": "ListItem",
              "position": i + 1,
              "name": p.title,
              "description": p.description,
            })),
          },
        }}
      />
      <Navbar />
      
      <PageHero
        title="Our Projects"
        subtitle="Real World Use Cases"
        description="Discover how we've helped organizations across the GCC transform their operations with sustainable mobility solutions."
        variant="vibrant"
      />

      <Breadcrumbs />

      <ProjectStats />

      {/* Projects Grid */}
      <section className="py-16 relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -left-40 top-1/4 w-80 h-80 rounded-full bg-eco-green/10 blur-3xl animate-pulse" />
          <div className="absolute -right-40 bottom-1/4 w-80 h-80 rounded-full bg-sky-blue/10 blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-primary/5 blur-3xl" />
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <VibrantSectionHeader
            badge="Case Studies"
            title="Featured Projects"
            description="See how we deliver sustainable mobility solutions across diverse industries"
            badgeColor="green"
          />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </div>
      </section>

      <ProjectProcess />

      <CTASection
        title="Have a Project in Mind?"
        description="Let's discuss how we can help transform your operations with sustainable mobility solutions."
        primaryButtonText="Start a Project"
        primaryButtonLink="/contact"
        secondaryButtonText="View Services"
        secondaryButtonLink="/services"
      />

      <Footer />
    </div>
  );
};

export default Projects;
